import { useMutation } from "@tanstack/react-query";

import queryClient from "single-spa/react-app/query-client";

import type { IUserKeywordGroup } from "../keywordGroups.types";
import { keywordGroupsQueryClient } from "../utils/keywordGroupsQueryClient";
import { updateKeywordGroup, keywordGroupsKeys } from "../queries/keywordGroupsQueries";

/**
 * @deprecated Use useUpdateKeywordGroupApiClient from pro-api-client instead.
 * This hook will be removed in a future version.
 * New implementations should use the API client version for better type safety and consistency.
 */
export const useUpdateKeywordGroup = () => {
    return useMutation<IUserKeywordGroup | null, Error, IUserKeywordGroup>({
        mutationFn: async (group) => {
            await updateKeywordGroup(group);
            await queryClient.invalidateQueries({ queryKey: keywordGroupsKeys.user() });
            await queryClient.invalidateQueries({ queryKey: keywordGroupsKeys.byId(group.Id) });
            const updatedGroup = await keywordGroupsQueryClient.getGroupById(group.Id);
            return updatedGroup;
        },
    });
};
